import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaImdb } from "react-icons/fa6";

const MovieCard = ({ item, isSelected }) => {
  const { genreList } = useSelector((state) => state.movie);
  const navigate = useNavigate();

  return (
    <div onClick={()=>navigate(`/movies/${item.id}`)}>
      <div className={`card_cont ${isSelected ? "selected" : ""}`}>
        <div
          className="movie_card"
          style={{
            backgroundImage:
              "url(" +
              `https://themoviedb.org/t/p/w355_and_h200_multi_faces${item.poster_path}` +
              ")",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        />
        <div className="overlay">
          <div className="card_info_inner">
            <strong className="card_deatail_title">{item.title}</strong>
            <div className="genre">
              {item.genre_ids.map((id, idx) => {
                const genre = genreList.genres.find((genre) => genre.id === id);
                return (
                  <span bg="warning" key={idx}>
                    {genre.name}
                  </span>
                );
              })}
            </div>
            <ul className="social-group">
              <li className="vote-average">
                <span className="imdb"><FaImdb size={30}/></span>
                {item.vote_average}
              </li>
              <li className="users">
                <span className="users-text">인기도 : {item.popularity}</span>
              </li>
              <li className="adult-info">
                <span>{item.adult ? "18+" : "under 18"}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MovieCard;
